var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerDiv"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(!_vm.isMobile())?_c('h2',{staticClass:"headingFooter"},[_vm._v("OMEGA ALPHA Ⓒ 2022")]):_vm._e(),_vm._v(" "),(_vm.isMobile())?_c('h4',{staticClass:"headingFooterMobile"},[_vm._v("OMEGA ALPHA Ⓒ 2022")]):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d4cd779","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homeComp/Footer.vue
// module id = null
// module chunks = 